import { Card, CardProps, Stack } from "@bps/fluent-ui";

interface ClaimsListCardProps extends CardProps {
  fullWidth?: boolean;
}

export const ClaimsListCard = ({
  children,
  fullWidth,
  ...props
}: ClaimsListCardProps) => {
  return (
    <Card
      {...props}
      headingLevel="section-heading-light"
      styles={{
        header: { padding: "8px 0 12px 8px" },
        subComponentStyles: {
          tile: {
            content: {
              padding: 0,
              position: "relative"
            },
            header: { border: "none" },
            root: {
              height: "100%",
              padding: 16,
              ...(!fullWidth && { maxWidth: 1500, margin: "0 auto" })
            }
          }
        }
      }}
    >
      <Stack styles={{ root: { height: "100%" } }}>{children}</Stack>
    </Card>
  );
};
